export const debounce = (callback, ms) => {
  let timeout;
  
  const cancel = () => {
    if (timeout) {
      clearTimeout(timeout);
    }
  };

  const debounced = (...args) => {
    cancel();
    timeout = setTimeout(() => callback(...args), ms);
  };

  debounced.cancel = cancel;
  return debounced;
};

export const isServer = () => typeof window === "undefined";
